const isNumeric = (v: unknown): v is number | `${number}` =>
  (typeof v === 'number' && Number.isFinite(v)) ||
  (typeof v === 'string' && v.trim() !== '' && Number.isFinite(Number(v)));

export const asPercent = (v: unknown) =>
  isNumeric(v) ? `${Math.round(Number(v) * 100)}%` : String(v ?? '');
